export const momentumData = [
  {
    Company: 'Adobe',
    SafeCompanyName: '',
    MomentumScore: 0.62,
    LatestPayGap: 10.7,
    XOffset: 8,
    YOffset: 0,
    XTooltipOffset: 10,
    YTooltipOffset: 20,
    CompanyColor: '#FF0000',
  },
  {
    Company: 'Amazon',
    SafeCompanyName: '',
    MomentumScore: 1.13,
    LatestPayGap: 11.18,
    XOffset: 8,
    YOffset: 0,
    XTooltipOffset: 10,
    YTooltipOffset: 20,
    CompanyColor: '#FF9900',
  },
  {
    Company: 'Apple',
    SafeCompanyName: '',
    MomentumScore: 1.41,
    LatestPayGap: 12.56,
    XOffset: -38,
    YOffset: 0,
    XTooltipOffset: 10,
    YTooltipOffset: -24,
    CompanyColor: '#808080',
  },
  {
    Company: 'Cisco',
    SafeCompanyName: '',
    MomentumScore: 0.05,
    LatestPayGap: 13.3,
    XOffset: -36,
    YOffset: 0,
    XTooltipOffset: 3,
    YTooltipOffset: -12,
    CompanyColor: '#1BA0D7',
  },
  {
    Company: 'Google',
    SafeCompanyName: '',
    MomentumScore: 0.87,
    LatestPayGap: 12.0,
    XOffset: -43,
    YOffset: 1,
    XTooltipOffset: 10,
    YTooltipOffset: -35,
    CompanyColor: '#0F9D58',
  },
  {
    Company: 'IBM',
    SafeCompanyName: '',
    MomentumScore: 0.03,
    LatestPayGap: 11.1,
    XOffset: 7,
    YOffset: 0,
    XTooltipOffset: 10,
    YTooltipOffset: 20,
    CompanyColor: '#052FAD',
  },
  {
    Company: 'Intel',
    SafeCompanyName: '',
    MomentumScore: 1.24,
    LatestPayGap: 22.68,
    XOffset: 8,
    YOffset: 1,
    XTooltipOffset: 0,
    YTooltipOffset: 0,
    CompanyColor: '#0071C5',
  },
  {
    Company: 'Microsoft',
    SafeCompanyName: '',
    MomentumScore: 0.15,
    LatestPayGap: 6.6,
    XOffset: 8,
    YOffset: 0,
    XTooltipOffset: 0,
    YTooltipOffset: 0,
    CompanyColor: '#F25022',
  },
  {
    Company: 'Netflix',
    SafeCompanyName: '',
    MomentumScore: -0.3,
    LatestPayGap: 21.8,
    XOffset: 8,
    YOffset: 0,
    XTooltipOffset: 0,
    YTooltipOffset: 0,
    CompanyColor: '#E50914',
  },
  {
    Company: 'Oracle',
    SafeCompanyName: '',
    MomentumScore: 0.29,
    LatestPayGap: 16.79,
    XOffset: 8,
    YOffset: 0,
    XTooltipOffset: 0,
    YTooltipOffset: 0,
    CompanyColor: '#C74634',
  },
  {
    Company: 'Salesforce',
    SafeCompanyName: '',
    MomentumScore: 1.84,
    LatestPayGap: 23.9,
    XOffset: 8,
    YOffset: -1,
    XTooltipOffset: 0,
    YTooltipOffset: 0,
    CompanyColor: '#1798C1',
  },
  {
    Company: 'Spotify',
    SafeCompanyName: '',
    MomentumScore: -0.27,
    LatestPayGap: 13.9,
    XOffset: 8,
    YOffset: 1,
    XTooltipOffset: 0,
    YTooltipOffset: -59,
    CompanyColor: '#1db954',
  },
  {
    Company: 'Tesla',
    SafeCompanyName: '',
    MomentumScore: 1.3,
    LatestPayGap: 0.7,
    XOffset: 8,
    YOffset: 0,
    XTooltipOffset: 0,
    YTooltipOffset: 0,
    CompanyColor: '#CC0000',
  },
  {
    Company: 'Uber',
    SafeCompanyName: '',
    MomentumScore: 0.77,
    LatestPayGap: 1.88,
    XOffset: -32,
    YOffset: 0,
    XTooltipOffset: 0,
    YTooltipOffset: 0,
    CompanyColor: '#1fbad6',
  },
];
